<script>
  import Navbar from "./Navbar.svelte";
  import PrivacyDialog from "./PrivacyDialog.svelte";

  import ShoppingList from "./ShoppingList.svelte";
  import { sidebarStore } from "./sideBar.js";
  import { Router, Route } from "svelte-routing";
  import Products from "./Products.svelte";
  import Scaffold from "./Scaffold.svelte";
  import CategoriesComponent from "./CategoriesComponent.svelte";
  import { searchStore } from './stores/state.js';
  import {Link} from 'svelte-routing';
  import ShoppingCart from "./ShoppingCart.svelte";
  import SearchBar from "./SearchBar.svelte";
  import SearchContext from "./SearchContext.svelte";
  import AboutUs from "./views/AboutUs.svelte";
  import {onMount} from 'svelte';
  import {navigate} from 'svelte-routing';
  import Success from "./Success.svelte";
  import CreateProduct from "./CreateProduct.svelte";
  import { auth } from "./firebase";
  import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";

  import { idToken } from './stores/id_token.js';
  import { privacyStore } from './stores/privacy.js';
  import categories from './stores/categories.js';
  import analytics from './services/analytics.js';


  let user;
  let currentPage;



  onMount(() => {
    // Initialize privacy settings
    privacyStore.initialize();
    
    // Firebase auth
    auth.onAuthStateChanged((firebaseUser) => {
      if (firebaseUser) {
        user = firebaseUser;
        firebaseUser.getIdToken(true)
          .then((token) => {
            idToken.set({
              token: token,
              email: firebaseUser.email,
            }); // Update the idToken store with the received ID Token
            
            // Track login event
            analytics.trackEvent('login', {
              method: 'Google'
            });
          });
      } else {
        user = null;
        idToken.set(null);
      }
    });
    
    // Navigate to the current URL
    navigate(window.location.pathname);
  });

  function login() {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider);
  }

  function logout() {
    analytics.trackEvent('logout');
    auth.signOut();
  }

  function onCategorySelected(category) {
    searchStore.updateCategory(category);
    sidebarStore.update((_) => false);
    
    // Track category selection
    analytics.trackEvent('select_category', {
      category_name: category ? category.name : 'all'
    });
  }

  let screenSize;
</script>

<svelte:window bind:innerWidth={screenSize} />

<PrivacyDialog />

<Router url="/">
  <Route path="/success/:orderId" let:params>
    <Navbar {sidebarStore} />
    <Success orderId={params.orderId} />
  </Route>
  <Route path="/">
    <SearchContext>
      <Scaffold {sidebarStore}>
        <div slot="side">
          {#if screenSize < 768}
            <div class="button mb-6">
              <Link to="/about" class="no-underline">Как работи</Link>
            </div>
            {#if user}
              <p class="text-white">Здр, {user.displayName}!</p>
              <div class="button mb-6">
                <button on:click={logout} class="no-underline">Излез</button>
              </div>
            {:else}
              <div class="button mb-6">
                <button on:click={login} class="no-underline">Админ</button>
              </div>
            {/if}

          {/if}
          <CategoriesComponent {categories} {onCategorySelected} />
        </div>
        <div>
          {#if screenSize >= 768}
            <Navbar {sidebarStore}>
              <div slot="left" class="flex flex-row gap-4 items-center">
                {#if user}
                  <div class="w-24 whitespace-nowrap overflow-hidden">
                    <p class="text-white">Здр, {user.displayName.split(' ')[0]}!</p>
                  </div>
                  <div class="button w-32">
                    <button on:click={logout} class="no-underline">Излез</button>
                  </div>
                {:else}
                  <div class="button w-32">
                    <button on:click={login} class="no-underline">Админ</button>
                  </div>
                {/if}
                <div class="button w-32">
                  <Link to="/about" class="no-underline">Как работи</Link>
                </div>
              </div>
              <SearchBar />
              <div class="w-3"></div>
              <ShoppingCart />
            </Navbar>
          {:else}
            <Navbar {sidebarStore}>
              <SearchBar />
              <div class="w-3"></div>
              <ShoppingCart />
            </Navbar>
          {/if}

          <Products />
        </div>
      </Scaffold>
    </SearchContext>
  </Route>
  <Route path="/cart">
    <!-- <Scaffold {sidebarStore}> -->
      <!-- <div> -->
        <Navbar {sidebarStore} />
        <ShoppingList />
      <!-- </div> -->
    <!-- </Scaffold> -->
  </Route>
  <Route path="/about">
    <!-- <Scaffold {sidebarStore}> -->
      <!-- <div> -->
        <Navbar {sidebarStore} rounded={false}>
        </Navbar>
        <AboutUs />
      <!-- </div> -->
    <!-- </Scaffold> -->
  </Route>
  <Route path="/create-product">
    <Navbar {sidebarStore} rounded={false}>
    </Navbar>
    <CreateProduct />
  </Route>

</Router>
